import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import HpLayout from '@/layouts/HpLayout.vue';
import LpLayout from '@/layouts/LpLayout.vue';

const HomePageJP = () => import(/* webpackChunkName: "hp-views" */ '@/views/hp/HomePageJP.vue');
const HomePageEN = () => import(/* webpackChunkName: "hp-views" */ '@/views/hp/HomePageEN.vue');
const NotFound = () => import(/* webpackChunkName: "hp-views" */ '@/errors/hp/NotFound.vue');
const RecruitPage = () => import(/* webpackChunkName: "lp-views" */ '@/views/lp/RecruitPage.vue');
const ThanksPage = () => import(/* webpackChunkName: "lp-views" */ '@/views/lp/ThanksPage.vue');

const routes = [
  {
    path: '/',
    name: 'HomeJP',
    component: HomePageJP,
    meta: { layout: HpLayout }
  },
  {
    path: '/english',
    name: 'HomeEN',
    component: HomePageEN,
    meta: { layout: HpLayout }
  },
  {
      name: 'NotFound',
      path: '*',
      component: NotFound,
      meta: { title: 'お探しのページは見つかりませんでした', layout: HpLayout }
  },
  {
    path: '/3fb2950166ffcd90de8bcc56756543e8b5a9adc9',
    name: 'Recruit',
    component: RecruitPage,
    meta: { layout: LpLayout }
  },
  {
  path: '/3fb2950166ffcd90de8bcc56756543e8b5a9adc9/thanks',
  name: 'Thanks',
  component: ThanksPage,
  meta: { layout: LpLayout }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;